import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface GuideStore {
  seen: boolean;
  open: boolean;
  markSeen: () => void;
  openGuide: () => void;
  closeGuide: () => void;
}

// Bump the key suffix (e.g. "lp-seed-v2") to show a guide again after its content changes.
export const createGuideStore = (key: string) =>
  create<GuideStore>()(
    persist(
      (set) => ({
        seen: false,
        open: false,
        markSeen: () => set({ seen: true }),
        openGuide: () => set({ open: true }),
        closeGuide: () => set({ open: false, seen: true }),
      }),
      {
        name: `vl-guide:${key}`,
        partialize: (state) => ({ seen: state.seen }),
      },
    ),
  );

export type GuideStoreHook = ReturnType<typeof createGuideStore>;
